import { render, staticRenderFns } from "./ProgramResourceWidget.vue?vue&type=template&id=7f5cee5a&scoped=true"
import script from "./ProgramResourceWidget.vue?vue&type=script&lang=js"
export * from "./ProgramResourceWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgramResourceWidget.vue?vue&type=style&index=0&id=7f5cee5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5cee5a",
  null
  
)

export default component.exports